import { useEffect } from 'react';
import { FormInstance } from 'antd/lib/form';

export const useFormInit = (form: FormInstance, data: any) => {
	useEffect(() => {
		form.setFieldsValue(data);
	}, [data, form]);
};
